import { SupportedLocales } from '@/models/localization.model';
import { IPagination, IPaginationDTO } from './pagination.model';

export enum MetaTagsEndpoints {
  META_TAGS = '/meta-tags',
}

export interface IMetaTag {
  id: string;
  created_at: string;
  updated_at: string;
  slug: string;
  index: boolean;
  locale?: {
    title?: string;
    description?: string;
    keywords?: string[];
    locale: SupportedLocales;
    text?: string;
  }[];
}

// ----------------- DTOs ----------------

export interface IGetMetaTagsDTO extends Partial<IPaginationDTO> {
  slug?: string;
}

export interface IGetMetaTagDTO {
  id: string;
}

export interface ICreateMetaTagDTO {
  slug: string;
  index: '1' | '0';
  locale?: Record<
    string,
    {
      title?: string;
      description?: string;
      keywords?: string[];
    }
  >;
}

export interface IUpdateMetaTagDTO extends Partial<ICreateMetaTagDTO> {
  id: string;
}

export interface IDeleteMetaTagDTO {
  id: string;
}

// ------------ Responses --------------

export interface IGetMetaTagResponse {
  data: IMetaTag;
}

export interface IGetMetaTagsResponse {
  data: IMetaTag[];
  meta: IPagination;
}
